export const environment = {
  production: false,
  apiUrl: "https://agent-gateway.carepoint-dev-app.prj.gcp.wellsky.io/api/v1",
  enableServiceWorker: true, // Enable service worker for development
  hookdeckApiBaseUrl:
    "https://us-east4-carepoint-dev-dmz-wsky.cloudfunctions.net/hookdeck-proxy-cloud-function",
  hookdeckApiKey: "1bqavpiwtuwsx32vacudus4rtnsjx132cpbdjtm350k0o0zrhd",
  apiKey: "00000000000000000000000001", // API key for development environment

  webhookPollingIntervalMs: 3000, // Default polling interval in milliseconds
  webhookPollingTimeoutMinutes: 5, // Default polling timeout in minutes
  webhookPollingMaxRetries: 3,
  webhookPollingRetryDelayMs: 3000,
};
